import React from 'react'
import ReactDOM from 'react-dom/client'

import { ContactDetail } from '../pages/contact'

const rootEl = document.getElementById('root')
if (rootEl) {
  const root = ReactDOM.createRoot(rootEl)
  root.render(
    <React.StrictMode>
      <ContactDetail />
    </React.StrictMode>
  )
}
